import { useState } from "react";
import api from "../lib/apiClient";

export default function OrderLookup() {
  const [form, setForm] = useState({
    order_id: localStorage.getItem("ts_last_order_id") || "",
    email: localStorage.getItem("ts_last_order_email") || "",
  });
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    setErr(""); setOrder(null); setLoading(true);
    try {
      const { data } = await api.get("/orders/lookup", { params: form });
      setOrder(data);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Not found.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="order-lookup-page" className="mx-auto max-w-3xl px-4 py-16">
      <p className="text-blood text-xs tracking-[0.3em] font-mono mb-2">// ORDER LOOKUP</p>
      <h1 className="font-anton uppercase text-bone text-5xl sm:text-6xl tracking-tighter">
        TRACK YOUR <span className="text-blood">DROP</span>
      </h1>

      <form onSubmit={lookup} className="mt-10 grid sm:grid-cols-2 gap-3 border border-white/15 p-6">
        <input data-testid="lookup-order-id" required value={form.order_id} onChange={(e) => setForm({ ...form, order_id: e.target.value })} placeholder="ORDER ID" className="bg-surface border border-white/20 px-4 py-3 text-bone text-sm focus:border-blood focus:outline-none" />
        <input data-testid="lookup-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="EMAIL" className="bg-surface border border-white/20 px-4 py-3 text-bone text-sm focus:border-blood focus:outline-none" />
        <button data-testid="lookup-submit" type="submit" className="sm:col-span-2 mt-2 px-6 py-3 bg-blood text-bone text-xs tracking-[0.3em] uppercase hover:bg-bone hover:text-ink">
          {loading ? "SEARCHING..." : "TRACK →"}
        </button>
      </form>

      {err && <p data-testid="lookup-error" className="font-marker text-blood text-2xl mt-6">{err}</p>}

      {order && (
        <div data-testid="lookup-result" className="mt-10 border border-white/15 p-6 space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[11px] tracking-[0.2em] uppercase text-ash font-mono">// STATUS</p>
              <p className="font-anton text-2xl uppercase text-bone">{order.status}</p>
            </div>
            <span className={`px-3 py-1 text-[11px] tracking-[0.2em] uppercase ${order.payment_status === "paid" ? "bg-blood text-bone" : "border border-white/20 text-ash"}`}>
              {order.payment_status}
            </span>
          </div>
          <div className="text-sm text-bone font-mono space-y-1">
            <p><span className="text-ash">ORDER:</span> {order.id}</p>
            <p><span className="text-ash">TOTAL:</span> ${order.total?.toFixed(2)} {order.currency?.toUpperCase()}</p>
            <p><span className="text-ash">SHIP TO:</span> {order.shipping_address}, {order.city} {order.postal_code}, {order.country}</p>
          </div>
          <div className="border-t border-white/15 pt-3">
            <p className="text-[11px] tracking-[0.2em] uppercase text-ash mb-2">// ITEMS</p>
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm text-bone py-1">
                <span>{it.name} <span className="text-ash">/ {it.size} × {it.quantity}</span></span>
                <span className="font-mono">${(it.price * it.quantity).toFixed(2)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
